<template>
  <section class="use-cases-section" ref="sectionRef">
    <div class="use-cases-container">
      <!-- Header de la sección -->
      <div class="section-header">
        <h2 class="main-title" ref="titleRef">
          Casos de uso de
          <span class="highlight">Fourin Track</span>
        </h2>
        <p class="subtitle" ref="subtitleRef">
          Solución CMMS en la nube para mantenimiento preventivo y predictivo, con sensores
          inteligentes y monitoreo en tiempo real, adaptada a cualquier sector.
        </p>
      </div>

      <!-- Contenido de dos columnas -->
      <div class="use-cases-grid">
        <!-- Columna izquierda: Empresas de Mantenimiento -->
        <div class="use-case-card maintenance">
          <div class="card-content">
            <div class="card-header">
              <div class="icon-container">
                <!-- Icono SVG Profesional -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"
                  ></path>
                </svg>
              </div>
              <h3 class="card-title">Empresas de Mantenimiento</h3>
            </div>
            <p class="card-description">
              Gestiona órdenes de servicio, seguimiento de técnicos y evidencias fotográficas.
              Control total del cumplimiento contractual.
            </p>
            <ul class="features-list">
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Creación y cierre de órdenes con trazabilidad total</span>
              </li>
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Seguimiento de técnicos en campo</span>
              </li>
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Adjuntos de fotos y documentos</span>
              </li>
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Control de avances y cumplimiento de ordenes</span>
              </li>
            </ul>
          </div>
          <div class="card-image">
            <img src="/src/assets/images/worker-cherry-picker.png" alt="Flota de camiones" />
          </div>
        </div>

        <!-- Columna derecha: Flota Vehicular -->
        <div class="use-case-card fleet">
          <div class="card-image top">
            <img src="/src/assets/images/maintenance-vans.png" alt="Trabajador en plataforma" />
          </div>
          <div class="card-content">
            <div class="card-header">
              <div class="icon-container">
                <!-- Icono SVG Profesional -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <!--Boxicons v3.0 https://boxicons.com | License  https://docs.boxicons.com/free-->
                  <path
                    d="m19.1,7.8c-.38-.5-.97-.8-1.6-.8h-2.5v-1c0-1.1-.9-2-2-2H4c-1.1,0-2,.9-2,2v10c0,1.1.9,2,2,2,0,1.65,1.35,3,3,3s3-1.35,3-3h4c0,1.65,1.35,3,3,3s3-1.35,3-3c1.1,0,2-.9,2-2v-3.67c0-.43-.14-.86-.4-1.2l-2.5-3.33Zm-1.6,1.2l1.5,2h-4v-2h2.5Zm-10.5,10c-.55,0-1-.45-1-1,0-.17.05-.35.13-.5.37-.63,1.36-.63,1.73,0,0,0,0,0,0,0,.09.15.13.32.13.49,0,.55-.45,1-1,1Zm2.23-3s-.05-.05-.08-.07c-.06-.06-.12-.11-.17-.16-.12-.11-.25-.21-.38-.29-.07-.05-.14-.09-.22-.13-.15-.08-.3-.14-.45-.19-.07-.02-.14-.05-.21-.07-.23-.06-.47-.09-.72-.09s-.49.04-.72.09c-.07.02-.14.05-.21.07-.16.05-.31.11-.45.19-.07.04-.15.08-.22.13-.13.09-.26.18-.38.29-.06.05-.12.1-.18.16-.02.03-.05.04-.08.07h-.77V6h9s0,2,0,2v8h-3.77Zm7.77,3c-.55,0-1-.45-1-1,0-.17.05-.35.13-.5.37-.63,1.36-.63,1.73,0,0,0,0,0,0,0,.09.15.13.32.13.49,0,.55-.45,1-1,1Zm3-3h-.77s-.05-.05-.08-.07c-.06-.06-.12-.11-.17-.16-.12-.11-.25-.21-.38-.29-.07-.05-.14-.09-.22-.13-.15-.08-.3-.14-.45-.19-.07-.02-.14-.05-.21-.07-.23-.06-.47-.09-.72-.09s-.47.04-.7.09c-.06.01-.12.03-.18.05-.18.06-.36.13-.52.22-.04.02-.08.04-.12.06-.17.1-.33.21-.48.35v-2.76h5v3Z"
                  ></path>
                </svg>
              </div>
              <h3 class="card-title">Flota vehicular</h3>
            </div>
            <p class="card-description">
              Programa mantenimientos preventivos, recibe alertas automáticas y reduce paradas
              imprevistas para extender la vida útil.
            </p>
            <ul class="features-list">
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Recordatorios por kilometraje o tiempo</span>
              </li>
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Historial de reparaciones y costos</span>
              </li>
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Reducción de averías y gastos mayores</span>
              </li>
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Mayor disponibilidad y seguridad de la flota</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="use-cases-grid">
        <!-- Columna izquierda: Planta industrial -->
        <div class="use-case-card maintenance">
          <div class="card-content">
            <div class="card-header">
              <div class="icon-container">
                <!-- Icono SVG Profesional -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <!--Boxicons v3.0 https://boxicons.com | License  https://docs.boxicons.com/free-->
                  <path d="M11 14h2v2h-2zM15 14h2v2h-2zM7 14h2v2H7z"></path>
                  <path
                    d="M8 3H4c-.55 0-1 .45-1 1v15c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V6c0-.4-.24-.77-.62-.92a.99.99 0 0 0-1.09.22L17 7.59V6c0-.4-.24-.77-.62-.92a.98.98 0 0 0-1.09.22L13 7.59V6c0-.4-.24-.77-.62-.92a.99.99 0 0 0-1.09.22L9 7.59V4c0-.55-.45-1-1-1m3 5.41V10c0 .4.24.77.62.92.37.16.8.07 1.09-.22L15 8.41V10c0 .4.24.77.62.92.37.16.8.07 1.09-.22L19 8.41V18H5V5h2v5c0 .4.24.77.62.92.37.16.8.07 1.09-.22z"
                  ></path>
                </svg>
              </div>
              <h3 class="card-title">Planta industrial</h3>
            </div>
            <p class="card-description">
              Registra maquinaria crítica, planifica mantenimientos según horas de uso y garantiza
              la continuidad operativa con trazabilidad completa.
            </p>
            <ul class="features-list">
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Registro detallado de cada máquina</span>
              </li>
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Programación basada en horas de operación</span>
              </li>
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Alertas de desgaste y fallas potenciales</span>
              </li>
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Trazabilidad histórica de mantenimientos</span>
              </li>
            </ul>
          </div>
          <div class="card-image">
            <img src="/src/assets/images/factory.png" alt="Flota de camiones" />
          </div>
        </div>

        <!-- Columna derecha: Refrigeración comercial -->
        <div class="use-case-card fleet">
          <div class="card-image top">
            <img src="/src/assets/images/cold.png" alt="Trabajador en plataforma" />
          </div>
          <div class="card-content">
            <div class="card-header">
              <div class="icon-container">
                <!-- Icono SVG Profesional -->
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <!--Boxicons v3.0 https://boxicons.com | License  https://docs.boxicons.com/free-->
                  <path
                    d="m20.71 8.71-1.42-1.42-3.7 3.71H13V8.41l3.71-3.7-1.42-1.42L13 5.59V2h-2v3.59l-2.29-2.3-1.42 1.42L11 8.41V11H8.41l-3.7-3.71-1.42 1.42L5.59 11H2v2h3.59l-2.3 2.29 1.42 1.42L8.41 13H11v2.59l-3.71 3.7 1.42 1.42 2.29-2.3V22h2v-3.59l2.29 2.3 1.42-1.42-3.71-3.7V13h2.59l3.7 3.71 1.42-1.42-2.3-2.29H22v-2h-3.59z"
                  ></path>
                </svg>
              </div>
              <h3 class="card-title">Refrigeración comercial</h3>
            </div>
            <p class="card-description">
              Monitorea y mantiene equipos de refrigeración en tiempo real. Evita pérdidas por
              fallas y cumple normativas de mantenimiento.
            </p>
            <ul class="features-list">
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Sensores para temperatura, humedad y funcionamiento</span>
              </li>
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Alertas tempranas de anomalías</span>
              </li>
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Registro de incidentes y soluciones</span>
              </li>
              <li class="feature-item">
                <div class="check-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M20 6L9 17l-5-5"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <span>Cumplimiento de estándares de mantenimiento</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="consult-btn-container">
        <button class="consult-btn" @click="openModal">Solicitar demo</button>
      </div>
    </div>
    <DemoModal :show="isModalOpen" :url="brevoLink" @close="closeModal" />
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import DemoModal from './DemoModal.vue'
import { useDemoModal } from '../composables/useDemoModal'

gsap.registerPlugin(ScrollTrigger)

const { isModalOpen, brevoLink, openModal, closeModal } = useDemoModal()
// --- Referencias a los elementos del DOM ---
const sectionRef = ref<HTMLElement | null>(null)
const titleRef = ref<HTMLElement | null>(null)
const subtitleRef = ref<HTMLElement | null>(null)
// YA NO NECESITAMOS LA REFERENCIA PARA LAS TARJETAS
// const cardRefs = ref<HTMLElement[]>([]);
onMounted(() => {
  // 2. Usa nextTick para asegurar que el DOM está listo
  nextTick(() => {
    // --- DETECCIÓN DE VISIBILIDAD CON INTERSECTION OBSERVER ---
    if (sectionRef.value) {
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Solo cuando la sección es visible, iniciamos las animaciones
              initAnimations()
              observer.unobserve(entry.target) // Deja de observar después de activarse
            }
          })
        },
        { threshold: 0.3 },
      ) // 30% visible para activar

      observer.observe(sectionRef.value)
    }
  })
})

// Función que contiene todas las animaciones
const initAnimations = () => {
  // --- Animación del Header (sin cambios, ya era correcta) ---
  const headerTl = gsap.timeline({
    scrollTrigger: {
      trigger: sectionRef.value,
      start: 'top 80%',
      toggleActions: 'play none none none',
    },
  })

  headerTl
    .from(titleRef.value, { autoAlpha: 0, y: 30, duration: 0.8, ease: 'power2.out' })
    .from(subtitleRef.value, { autoAlpha: 0, y: 20, duration: 0.8, ease: 'power2.out' }, '-=0.6')

  // --- Animación de las Tarjetas ---
  const cards = gsap.utils.toArray<HTMLElement>('.use-case-card')

  // Ahora iteramos sobre este array que sí funciona.
  cards.forEach((card) => {
    const cardImage = card.querySelector('.card-image img')
    const cardContent = card.querySelector('.card-content')

    // Animación del contenido (sin cambios en la lógica)
    if (cardContent) {
      gsap.from(cardContent, {
        autoAlpha: 0,
        x: -40,
        duration: 1,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: card,
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
      })
    }

    // Animación de Paralaje (sin cambios en la lógica)
    if (cardImage) {
      gsap.to(cardImage, {
        yPercent: -30,
        ease: 'none',
        scrollTrigger: {
          trigger: card,
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      })
    }
  })
}
</script>

<style scoped>
.use-cases-section {
  padding: 120px 20px;
  background-color: #fff;
}
.use-cases-container {
  max-width: 1200px;
  margin: 0 auto;
}
.section-header {
  text-align: center;
  margin-bottom: 20px;
}

.main-title {
  font-size: clamp(2.5rem, 5vw, 3.5rem);
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 20px;
  line-height: 1.2;
}

.highlight {
  color: #129bef;
  font-weight: 700;
}

.subtitle {
  font-size: 1.125rem;
  line-height: 1.6;
  color: #64748b;
  margin: 0 auto;
  max-width: 750px;
}

.use-cases-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  margin-bottom: 40px;
  align-items: stretch;
}

.use-case-card {
  --mouse-x: 50%;
  --mouse-y: 50%;
  position: relative;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.6);
  border: 2px solid #e2e8f0;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  backdrop-filter: blur(8px);
  transition: all 0.3s ease-out;
}

.use-case-card:hover::before {
  opacity: 1;
}

.card-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
  z-index: 1;
}
.card-header {
  display: flex;
  align-items: center;
  gap: 16px;
}

.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: #e0f2fe;
  color: #129bef;
}

.card-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}
.card-description {
  font-size: 1rem;
  line-height: 1.6;
  color: #64748b;
  margin: 0;
}
.features-list {
  list-style: none;
  padding: 0;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
}
.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: #475569;
  font-size: 15px;
}

.check-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: #dbeafe;
  border-radius: 50%;
  color: #129bef;
  flex-shrink: 0;
  margin-top: 2px;
}

/* --- AJUSTES CLAVE PARA EL PARALAJE --- */
.card-image {
  width: 100%;
  border-radius: 16px;
  overflow: hidden; /* ¡Crucial! Oculta las partes de la imagen que se salen */
  margin-top: 30px;
  z-index: 1;
}

.card-image img {
  width: 100%;
  height: 120%; /* Hacemos la imagen un 20% más alta que su contenedor */
  object-fit: cover; /* Asegura que la imagen llene el espacio sin distorsionarse */
  display: block;
}

.card-image.top {
  margin-top: 0;
  margin-bottom: 30px;
}

@media (max-width: 968px) {
  .use-cases-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  .use-case-card.fleet {
    flex-direction: column-reverse;
  }
}

@media (max-width: 768px) {
  .use-cases-section {
    padding: 80px 15px;
  }
  .main-title {
    font-size: 2.25rem;
  }
  .subtitle {
    font-size: 1rem;
  }
}

/* Estilos para el botón de consulta */
.consult-btn-container {
  text-align: center;
  margin-top: 60px;
  margin-bottom: 40px;
}

.consult-btn {
  background: #129bef;
  color: white;
  border: none;
  padding: 18px 36px;
  border-radius: 50px;
  font-size: 1.125rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.consult-btn:hover {
  background: #0ea5e9;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(18, 155, 239, 0.4);
}

@media (max-width: 768px) {
  .consult-btn {
    padding: 14px 28px;
    font-size: 1rem;
  }
}
</style>
